import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui/box';
import { Typography, TypographyProps } from 'components/ui/typography';
import { useIsDesktopLargeBreakpoint } from 'hooks/use-media-query';
import { CCPAButtonLink } from 'pages/account/ccpa-button-link';
import { getDesignToken, primitive } from 'styles/constants';

const footerTextProps = {
  color: primitive.$mayoEggWhite,
  fontSize: 'xs',
} as const;

export const FooterText = ({
  children,
  style,
  ...props
}: React.PropsWithChildren<TypographyProps>) =>
  React.createElement(Typography, { ...footerTextProps, ...props, style }, children);

export const FooterCCPAButtonLink = (props: React.ComponentProps<typeof CCPAButtonLink>) =>
  React.createElement(CCPAButtonLink, {
    ...props,
    ...footerTextProps,
    _text: footerTextProps,
  });

export const FooterWrapper = ({ children, style, ...props }: React.PropsWithChildren<BoxProps>) => {
  const isDesktopLarge = useIsDesktopLargeBreakpoint();

  return React.createElement(
    Box,
    {
      ...props,
      style: [styles.footerWrapper, isDesktopLarge && styles.footerWrapperDesktop, style],
    },
    children
  );
};

const styles = StyleSheet.create({
  footerWrapper: {
    alignItems: 'center',
    backgroundColor: getDesignToken('color-contrast-background'),
    justifyContent: 'center',
    padding: 16,
  },
  footerWrapperDesktop: {
    flexDirection: 'row',
  },
});
